export const EXTERNAL_LINKS = {
  YOUTUBE_CHANNEL: 'https://www.youtube.com/@SimrLabs',
  YOUTUBE_COMMUNITY: 'https://www.youtube.com/@SimrLabs/posts',
  SAIL_TO_UNKNOWN_CONTAINER_BG:
    'https://downloads.simrlabs.com/images/game/sailtounkown/screen6.jpg',
} as const;

export type ExternalLinkKey = keyof typeof EXTERNAL_LINKS;
export type ExternalLinkUrl = (typeof EXTERNAL_LINKS)[ExternalLinkKey];
